import toCamelCase from 'lodash/camelCase';
import { isAnEcommerceEvent } from '../e-commerce';
/**
 * Convert all (except e-commerce events) to camel case as standard by data-analists.
 */
export const keysToCamelCase = (event) => {
    return Object.fromEntries(Object.entries(event).map(([key, value]) => [
        // e-commerce events are regulated and may contain snake-cased. These should not be converted.
        !isAnEcommerceEvent(event) ? toCamelCase(key) : key,
        value,
    ]));
};
